import { MsftPrivateOffer } from 'pages/PrivateOffers/pages/Next/msft/api/types/MsftPrivateOffer';
import { msftPrivateOfferToMsftCreateOfferJSON } from 'pages/PrivateOffers/pages/Next/msft/api/transformers/msftPrivateOfferToMsftCreateOfferJSON';
import { MsftUpdateOfferJSON } from '../types/MsftUpdateOfferJSON';

export const msftPrivateOfferToMsftUpdateOfferJSON = (
  offer: Partial<MsftPrivateOffer>,
): MsftUpdateOfferJSON => {
  const {
    offer_type,
    vendor_id,
    vendor_name,
    source,
    clone,
    ...updateOfferJSON
  } = msftPrivateOfferToMsftCreateOfferJSON(offer);

  return updateOfferJSON;
};
